export enum Units {
  Kg = 'Kg',
  Lbs = 'Lbs',
  T = 'T',
}
